module.exports = __webpack_public_path__ + "img/default.45138a9f.jpg";